export default __webpack_public_path__ + "static/media/icono_saturno_nosotros.a3c3d561.svg";